import merge from 'lodash/merge'
import es from '../es'
import tableroSeleccion from './tablero-seleccion.json'
import talentPool from './talent-pool.json'
import curriculum from './curriculum.json'
import dashboard from './dashboard.json'
import ecommerce from './ecommerce.json'
import homePage from './home-page.json'
import hunter from './hunter.json'
import signUp from './sign-up.json'
import productos from './productos.json'
import avisoPublicacion from './aviso-publicacion.json'
import avisoPublicacionProductos from './aviso-publicacion-productos.json'
import avisoProductos from './aviso-productos.json'
import statistics from './statistics.json'

const ec = {
  ...es,
  CV: 'HV',
  currency: 'USD',
  tableroSeleccion: merge({}, es.tableroSeleccion, tableroSeleccion),
  talentPool: merge({}, es.talentPool, talentPool),
  curriculum: merge({}, es.curriculum, curriculum),
  dashboard: merge({}, es.dashboard, dashboard),
  ecommerce: merge({}, es.ecommerce, ecommerce),
  homePage: merge({}, es.homePage, homePage),
  hunter: merge({}, es.hunter, hunter),
  signUp: merge({}, es.signUp, signUp),
  productos: merge({}, es.productos, productos),
  avisoPublicacion: merge({}, es.avisoPublicacion, avisoPublicacion),
  avisoPublicacionProductos: merge({}, es.avisoPublicacionProductos, avisoPublicacionProductos),
  avisoProductos: merge({}, es.avisoProductos, avisoProductos),
  statistics: merge({}, es.statistics, statistics),
}

export default ec
